<template>
    <h2
      :style="`
        text-align:`+position+`;
        font-size: `+(window.width<480? `12px`: `16px`)+`;
        font-weight: lighter;
        color:`+color"
    >
      {{ sondageName }}
    </h2>
</template>

<script>
export default {
  props: {
    sondageName: {
      required: true,
      type: String
    },
    color: {
      type: String,
      required: true
    },
    window: {
      required: true
    },
    position: {
      type: String,
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resultats/components/Title.vue